<template>
    <div>
        <div class="inline-form-group">
            <el-form-item label="Typ linku"
                          :error="anchorErrors()">
                <el-select v-model="form.anchor_type"
                           @change="resetOptions"
                           placeholder="Wybierz typ linku"
                           clearable>
                    <el-option v-for="option in anchorOptions"
                               :key="option.value"
                               :label="option.label"
                               :value="option.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Otwieraj w nowym oknie" label-width="200px">
                <el-switch v-model="form.target_blank"></el-switch>
            </el-form-item>
        </div>
        <el-form-item label="URL"
                      v-if="form.anchor_type === 'url'"
                      :error="errorsParsed.url">
            <el-input v-model="form.url"></el-input>
        </el-form-item>
        <div class="inline-form-group">
            <el-form-item label="Wydarzenie"
                          v-if="form.anchor_type === 'event'"
                          :error="errorsParsed.event">
                <el-select @change="delete form['widget']"
                           filterable
                           v-model="form.event"
                           placeholder="Wybierz wydarzenie">
                    <el-option v-for="option in availableLinkOptions.event"
                               :key="option.value"
                               :label="option.label"
                               :value="option.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Podstrona"
                          v-if="form.anchor_type === 'page'"
                          :error="errorsParsed.page">
                <el-select @change="delete form['widget']"
                           filterable
                           v-model="form.page"
                           placeholder="Wybierz podstronę">
                    <el-option v-for="option in availableLinkOptions.page"
                               :key="option.value"
                               :label="option.label"
                               :value="option.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Stoiska"
                          v-if="form.anchor_type === 'stand'"
                          :error="errorsParsed.stand">
                <el-select @change="delete form['widget']"
                           filterable
                           v-model="form.stand"
                           placeholder="Wybierz stoiska">
                    <el-option v-for="option in availableLinkOptions.stand"
                               :key="option.value"
                               :label="option.label"
                               :value="option.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Aktualność"
                          v-if="form.anchor_type === 'news'"
                          :error="errorsParsed.news">
                <el-select @change="delete form['widget']"
                           filterable
                           v-model="form.news"
                           placeholder="Wybierz aktualność">
                    <el-option v-for="option in availableLinkOptions.news"
                               :key="option.value"
                               :label="option.label"
                               :value="option.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Nazwa widgetu"
                          v-if="availableWidgets.length > 0"
                          :error="errorsParsed.widget">
                <span slot="label">
                    Nazwa widgetu
                    <el-tooltip content="Widget, do którego domyślnie przescrolluje się strona po kliknięciu w link." placement="bottom">
                        <el-button class="widget-info"><i class="fa fa-question-circle"></i></el-button>
                    </el-tooltip>
                </span>
                <el-select v-model="form.widget"
                           clearable
                           placeholder="Wybierz widget">
                    <el-option v-for="option in availableWidgets"
                               :key="option.id"
                               :label="option.name_pl"
                               :value="option.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </div>


    </div>
</template>
<script>
    import {Menu} from '@/api'

    export default {
        props: {
            "value": {type: Object},
            "errors": {
                type: [Object, String],
                default: () => {
                }
            }
        },
        mounted () {
            if (this.value) {
                this.form = Object.assign({}, this.value)
            }
            this.fetchData()
        },
        methods: {
            resetOptions () {
                if (this.form.anchor_type === '') {
                    setTimeout(() => {
                        this.$emit('input', null)
                    }, 0)
                    return
                }
                delete this.form.page
                delete this.form.event
                delete this.form.stand
                delete this.form.news
                this.form.url = ''
            },
            fetchData () {
                this.$store.dispatch('fetchAvailableLinkOptions')
                // Menu.availableLinkOptions().then(response => {
                //     this.availableLinkOptions = response.data
                // })
            },
            getAnchorObject () {
                const anchorType = this.form.anchor_type

                if (anchorType === undefined || anchorType === "url") {
                    return
                }

                const anchorObjectId = this.form[anchorType]
                let options = this.availableLinkOptions[anchorType]
                if (options === undefined) {
                    return
                }

                const findObj = item => item.value === anchorObjectId
                return options.find(findObj)
            },
            anchorErrors () {
                if (typeof this.errors === 'string') {
                    return this.errors
                } else {
                    const errors = this.errors && this.errors['anchor_type']
                    if (Array.isArray(errors)) {
                        return errors.join(', ')
                    } else {
                        return errors
                    }
                }
            }
        },
        computed: {
            availableWidgets () {
                if (this.form.anchor_type === 'url') return []
                const anchorObject = this.getAnchorObject()
                if (anchorObject) {
                    return anchorObject.widgets
                }
                return []
            },
            errorsParsed () {
                return this.errors || {}
            },
            availableLinkOptions () {
                return this.$store.state.availableLinkOptions
            }
        },
        watch: {
            form: {
                handler (value) {
                    this.$emit('input', value)
                },
                deep: true
            }
        },
        data () {
            return {
                form: {},
                anchorOptions: [
                    {"label": "URL", "value": "url"},
                    {"label": "Wydarzenie", "value": "event"},
                    {"label": "Podstrona", "value": "page"},
                    {"label": "Stoisko", "value": "stand"},
                    {"label": "News", "value": "news"},
                ],
            }
        }
    }
</script>
<style lang="scss" scoped>
    .widget-info {
        padding: 9px;
    }
</style>


// WEBPACK FOOTER //
// LinkComponent.vue?24e80086